import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Table, Text, cn, Modal, Breadcrumb } from "@artprov/design-system";
import { columnasRendiciones } from "../columnasRendiciones";
import { formatToARS } from "../../../../utils/number.utils";

export default function Contenido({
  data: rendiciones,
  isModalOpen,
  modalData,
  closeModal,
  setModalOpen,
  total,
}) {
  const location = useLocation()
  const { id } = useParams()
  const navigate = useNavigate()
  const [selectedRow, setSelectedRow] = useState([]);


  // TODO: Enviar a utils o reutilizar si existe.
  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function getBase64ToFIle(file) {
    const mime = file.contentType;
    const content = file.content;
    let base64 = `data:${mime};base64,${content}`;
    return base64;
  }

  function getDomImage(modalData) {
    return (
      <img
        className={cn("w-full")}
        src={getBase64ToFIle(modalData)}
        alt={modalData?.name ?? "n/a"}
      />
    );
  }

  function getIframePdf(modalData) {
    return (
      <iframe
        width={420}
        height={540}
        src={getBase64ToFIle(modalData)}
        title={modalData?.name ?? "n/a"}></iframe>
    );
  }

  function getHtmlViewer(modalData) {
    const { contentType } = modalData
    if (
      ["image/png", "image/jpeg", "image/jpg"].includes(contentType)
    ) {
      return getDomImage(modalData);
    } else if (["application/pdf"].includes(contentType)) {
      return getIframePdf(modalData);
    } else {
      return "No se encuentra archivo"
    }
  }

  return (
    <div
      className={`container mx-auto flex flex-col h-full  min-h-[800px] items-center my-8 px-2 xl:px-8`}>
      <div className="w-full flex flex-col justify-center gap-y-1 p-2">
        <Breadcrumb
          customItems={getBreadCrumbs()}
          onClick={(href) => {
            if (href) navigate(href);
          }}
        />
      </div>
      <div className="w-full flex flex-col justify-between p-1">
        <Text variant="h6" className="text-primary-10">
          Solicitud {id}
        </Text>
        <Text variant="body2 text-tertiary-0">
          Podés ver los comprobaste que enviaste en esta solicitud.
        </Text>
      </div>
      <div className="w-full min-h-[300px] flex flex-col gap-y-2 my-2">
        <Table
          data={rendiciones}
          columns={columnasRendiciones}
          selectable={false}
          selected={selectedRow}
        />
      </div>
      <div className="flex w-full pt-5 pb-5">
        <Text variant="body1" className="ml-auto">Total <span className="border-[1.5px] border-tertiary-90 px-2 py-[5px] text-tertiary-10 rounded text-nowrap inline-block w-[123px] text-right ml-5">{formatToARS(total)}</span></Text>
      </div>
      {isModalOpen && (
        <Modal.Container
          open={isModalOpen}
          setOpen={setModalOpen}
          onClose={closeModal}
          closeOnClickOutside={false}
          title="Comprobante adjunto">
          <Modal.Content
            className={cn("overflow-x-hidden")}
            width={489}
            height={677}>
            <Modal.Header>
              <Modal.Title>Comprobante adjunto<Text variant="body1">{modalData?.name ?? ''}</Text></Modal.Title>
              <Modal.Close onClose={() => closeModal()} />
            </Modal.Header>
            <Modal.Body
              className={cn("w-full")}>
              {getHtmlViewer(modalData)}
            </Modal.Body>
          </Modal.Content>
        </Modal.Container>
      )}
    </div>
  );
}

function getBreadCrumbs() {
  return [
    { label: "Inicio", href: "/", disabled: false },
    { label: "Detalle de Solicitud", disabled: true },
  ];
}